module.exports = __webpack_public_path__ + "img/bg_10_en.3f303f4d.png";